<template>
  <validation-observer
    ref="conductSaveFormRef"
    #default="{invalid}"
  >
    <b-modal
      id="conductSaveModal"
      body-class="position-static"
      centered
      :title="isCreated ? 'Thêm bộ tiêu chí' : 'Cập nhật bộ tiêu chí'"
      size="lg"
      :no-close-on-backdrop="true"
      @show="onShow"
      @hide="onHide"
    >
      <b-form>
        <b-row>
          <b-col
            sm="12"
            md="12"
            lg="6"
            xl="6"
          >
            <b-form-group label-for="trainingSystemId">
              <template v-slot:label>
                {{ trainingSystemLabel }} <span class="text-danger">*</span>
              </template>
              <validation-provider
                #default="{ errors }"
                :name="trainingSystemLabel"
                rules="required"
              >
                <v-select
                  v-model="targetConduct.trainingSystemId"
                  :options="trainingSystems"
                  :reduce="option => option.id"
                  label="name"
                  @input="onTrainingSystemsChange"
                />
                <b-form-invalid-feedback :state="getElementState(errors)">
                  {{ errors[0] }}
                </b-form-invalid-feedback>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            sm="12"
            md="12"
            lg="6"
            xl="6"
          >
            <b-form-group label-for="courseId">
              <template v-slot:label>
                Khóa học <span class="text-danger">*</span>
              </template>
              <validation-provider
                #default="{ errors }"
                name="Khóa học"
                rules="required"
              >
                <v-select
                  id="selectCourses"
                  v-model="targetConduct.courseId"
                  :options="courses"
                  :reduce="option => option.id"
                  label="name"
                  @input="onCoursesChange"
                />
                <b-form-invalid-feedback :state="getElementState(errors)">
                  {{ errors[0] }}
                </b-form-invalid-feedback>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            sm="12"
            md="12"
            lg="6"
            xl="12"
          >
            <b-form-group label-for="courseSemesterId">
              <template v-slot:label>
                Học kỳ <span class="text-danger">*</span>
              </template>
              <validation-provider
                #default="{ errors }"
                name="Học kỳ"
                rules="required"
              >
                <v-select
                  v-model="targetConduct.courseSemesterId"
                  :options="courseSemesters"
                  :reduce="option => option.value"
                />
                <b-form-invalid-feedback :state="getElementState(errors)">
                  {{ errors[0] }}
                </b-form-invalid-feedback>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            sm="12"
            md="12"
            lg="6"
            xl="12"
          >
            <b-form-group label-for="name">
              <template v-slot:label>
                Tên bộ tiêu chí <span class="text-danger">*</span>
              </template>
              <validation-provider
                #default="{ errors }"
                name="Tên bộ tiêu chí"
                rules="required"
              >
                <b-form-input
                  id="name"
                  v-model="targetConduct.name"
                  name="name"
                  placeholder="Nhập tên bộ tiêu chí"
                  :state="getElementState(errors)"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            sm="12"
            md="12"
            lg="6"
            xl="6"
          >
            <b-form-group label-for="status">
              <template v-slot:label>
                Trạng thái <span class="text-danger">*</span>
              </template>
              <validation-provider
                #default="{ errors }"
                name="Trạng thái"
                rules="required"
              >
                <v-select
                  v-model="targetConduct.status"
                  :options="statusOptions"
                  :reduce="option => option.value"
                />
                <b-form-invalid-feedback :state="getElementState(errors)">
                  {{ errors[0] }}
                </b-form-invalid-feedback>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            sm="12"
            md="12"
            lg="6"
            xl="6"
          >
            <b-form-group label-for="orderNo">
              <template v-slot:label>
                Thứ tự <span class="text-danger">*</span>
              </template>
              <validation-provider
                #default="{ errors }"
                name="Thứ tự"
                rules="required|numeric"
              >
                <b-form-input
                  id="orderNo"
                  v-model="targetConduct.orderNo"
                  name="orderNo"
                  placeholder="Nhập thứ tự"
                  :state="getElementState(errors)"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
      <template #modal-footer>
        <div class="w-100 d-flex justify-content-end">
          <b-button
            v-show="isCreated"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-1"
            :disabled="invalid"
            @click="onSave"
          >
            <span class="text-right">
              <feather-icon icon="CheckIcon" /> Lưu và tiếp tục
            </span>
          </b-button>

          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-1"
            :disabled="invalid"
            @click="onSave('hide')"
          >
            <span class="text-right">
              <feather-icon icon="CheckIcon" /> Lưu lại
            </span>
          </b-button>

          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="outline-secondary"
            @click="$bvModal.hide('conductSaveModal')"
          >
            <span class="text-right">
              <feather-icon icon="XIcon" /> Hủy
            </span>
          </b-button>
        </div>
      </template>
      <b-overlay
        variant="white"
        spinner-variant="primary"
        blur="0"
        opacity=".75"
        rounded="sm"
        no-wrap
        :show="isLoading"
      />
    </b-modal>
  </validation-observer>
</template>

<script>
import {
  BButton,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BModal,
  BOverlay,
  BRow,
} from 'bootstrap-vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { numeric, required } from '@validations'
import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Ripple from 'vue-ripple-directive'
import { STATUSES } from '@/const/status'
import { getUser } from '@/auth/utils'
import { OrganizationCode } from '@/const/code'
import api from './api'

export default {
  name: 'ConductSave',
  components: {
    BCol,
    BRow,
    BFormGroup,
    BFormInput,
    BModal,
    BForm,
    BOverlay,
    BFormInvalidFeedback,
    BButton,
    vSelect,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  props: {
    conduct: {
      type: Object,
      default: undefined,
    },
  },
  data() {
    return {
      user: getUser(),
      isLoading: false,
      courses: [],
      trainingSystems: [],
      courseSemesters: [],
      targetConduct: {
        trainingSystemId: null,
        courseId: null,
        courseSemesterId: null,
        maxScore: 0,
        name: '',
        status: 1,
        orderNo: 1,
      },
      required,
      numeric,
    }
  },
  computed: {
    statusOptions() {
      return STATUSES
    },
    isCreated() {
      return !this.conduct
    },
    trainingSystemLabel() {
      return getUser().orgCode === OrganizationCode.HLUV ? 'Hệ đào tạo' : 'Hình thức đào tạo'
    },
  },
  methods: {
    getElementState(errors) {
      return errors.length > 0 ? false : null
    },
    async onShow() {
      this.trainingSystems = await api.getTrainingSystemsByOrganizationId({ organizationId: this.user.organizationId })
      if (this.conduct) {
        this.targetConduct = { ...this.conduct }
        this.courses = await api.getCoursesByTrainingSystemId({ trainingSystemId: this.targetConduct.trainingSystemId })
        this.courseSemesters = await api.getCourseSemestersByCourseId({ courseId: this.targetConduct.courseId })
      } else {
        this.targetConduct = { ...this.targetConduct, organizationId: this.user.orgId }
      }
    },
    onHide() {
      this.$refs
        .conductSaveFormRef
        .reset()
      this.targetConduct = {
        trainingSystemId: null,
        courseId: null,
        courseSemesterId: null,
        maxScore: 0,
        name: '',
        status: 1,
        orderNo: 1,
      }
    },
    async onTrainingSystemsChange(event) {
      try {
        this.targetConduct.trainingSystemId = event
        this.targetConduct.courseId = null
        this.courses = await api.getCoursesByTrainingSystemId({ trainingSystemId: this.targetConduct.trainingSystemId })
        if (event !== null && this.courses.length > 0) {
          this.targetConduct.courseId = this.courses[0].value
        }
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: error,
            icon: 'XCircleIcon',
            variant: 'danger',
          },
        })
      }
    },

    async onCoursesChange(event) {
      try {
        this.targetConduct.courseId = event
        this.targetConduct.courseSemesterId = null
        const request = { ...this.filter }
        delete request.itemsPerPage

        this.courseSemesters = await api.getCourseSemestersByCourseId({ courseId: this.targetConduct.courseId })
        if (this.courseSemesters.length > 0) {
          this.targetConduct.courseSemesterId = this.courseSemesters[0].value
        }
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: error,
            icon: 'XCircleIcon',
            variant: 'danger',
          },
        })
      }
    },
    async onSave(type = null) {
      const valid = this.$refs
        .conductSaveFormRef
        .validate()
      if (valid) {
        this.isLoading = true
        try {
          const response = this.isCreated
            ? await api.createConduct(this.targetConduct)
            : await api.updateConduct(this.targetConduct)
          if (response) {
            const { isSuccessful, message } = response
            if (isSuccessful) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: message,
                  icon: 'CheckIcon',
                  variant: 'success',
                },
              })
              if (type === 'hide') {
                this.$bvModal.hide('conductSaveModal')
              }
              this.$emit('succeed')
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: message,
                  icon: 'XCircleIcon',
                  variant: 'danger',
                },
              })
            }
          }
        } catch (e) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: `[${e.code}] ${e.message}`,
              icon: 'XCircleIcon',
              variant: 'danger',
            },
          })
        } finally {
          this.isLoading = false
        }
      }
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
